import { IAdminFlight } from '../../eventFlights/store';

import api, { request } from '../../../../api';
import { IStore } from '../../../';

export const removeFlight = async (state: IStore, clubId: number, flight: IAdminFlight) => {
  const response = await request.delete(`${api.admin.flights(clubId, flight.event)}${flight.id}/`);

  if (response.error) {
    const err =
      (response.error.statusText && response.error.statusText.join('. ')) || response.error.status;
    return { errors: { events: { msg: 'Error deleting the flight: ' + err } } };
  }

  const newFlights = state.adminEvents[flight.event].flights.filter(
    (f: IAdminFlight) => f.id !== flight.id
  );

  return {
    adminEvents: {
      all: {
        ...state.adminEvents.all,
        [flight.event]: {
          ...state.adminEvents[flight.event],
          flights: newFlights
        }
      },
      current: {
        ...state.adminEvents[flight.event],
        flights: newFlights
      },
      [flight.event]: {
        ...state.adminEvents[flight.event],
        flights: newFlights
      }
    }
  };
};
